<template>
  <div class="top">
    <div class="in">
      <div class="iin">
        <div class="content">
          <a
            href="/"
            style="display:block; height:120px; width:120px; position:absolute; left:30px; top:50px;"
          ></a>

          <div id="ctl00_HeaderCalculation_MainCalcHeader1_UpdatePanel1">
            <div class="calculation">
              <div class="items">
                <h5>VAŠE NAPRAVE</h5>
                <ul>
                  <li
                    v-for="(apps, key) in display_arr"
                    :key="key"
                    :class="key"
                    @mouseover="app_hover = key"
                    @mouseleave="app_hover = '' "
                  >
                    <span>{{ apps.length }}</span>
                    {{ key }}
                    <div
                      class="item-details"
                      :style="{display: app_hover == key ? 'block' : 'none'}"
                    >
                      <div class="item-details-in">
                        <div class="item-details-iin">
                          <div class="t-head">
                            <h1>{{ key }} - {{apps.length}}</h1>
                            <a>Dodaj</a>
                          </div>
                          <div class="t-con">
                            <div v-for="(app, i) in apps" :key="i">
                              <a>
                                <em></em>
                                <span>{{ app.name }} {{i+1}},</span>
                                <span class="class">{{ app.detail_string }}</span>
                                <strong>{{app.st_ukrepov}} ukrepov</strong>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="first">
                <h5>VAŠA TRENUTNA PORABA</h5>
                <span id="ctl00_HeaderCalculation_MainCalcHeader1_Label1" class="et">
                  79 kWh / leto
                  <div class="tooltip-bottom">
                    Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
                    <br />
                    <a
                      href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                      target="_blank"
                      title="Več"
                    >Več o tem &gt;</a>
                  </div>
                </span>
                <em>
                  <span id="ctl00_HeaderCalculation_MainCalcHeader1_Label2">6 € / leto</span>
                </em>
              </div>
              <div id="ctl00_HeaderCalculation_MainCalcHeader1_tdSavings">
                <h5>VAŠI PRIHRANKI</h5>
                <span id="ctl00_HeaderCalculation_MainCalcHeader1_Label11" class="et">
                  11 kWh
                  <span class="save">13</span>%
                  <div class="tooltip-bottom">
                    Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
                    <br />
                    <a
                      href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                      target="_blank"
                      title="Več"
                    >Več o tem &gt;</a>
                  </div>
                </span>
                <em>
                  <span id="ctl00_HeaderCalculation_MainCalcHeader1_Label12">1 € / leto</span>
                </em>
              </div>
              <div id="ctl00_HeaderCalculation_MainCalcHeader1_tdNewConsumption">
                <h5>VAŠA NOVA PORABA</h5>
                <span id="ctl00_HeaderCalculation_MainCalcHeader1_Label6" class="et">
                  68 kWh
                  <div class="tooltip-bottom">
                    Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
                    <br />
                    <a
                      href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                      target="_blank"
                      title="Več"
                    >Več o tem &gt;</a>
                  </div>
                </span>
                <em>
                  <span id="ctl00_HeaderCalculation_MainCalcHeader1_Label7">5 € / leto</span>
                </em>
              </div>

              <ul class="buttons">
                <li class="add-box-trigger">
                  <a href="#" title="+ Dodaj" @mouseover="add_hover = 'block'">+ Dodaj</a>
                  <div
                    class="add-box"
                    :style="{display: add_hover}"
                    @mouseleave="add_hover = 'none'"
                  >
                    <ul>
                      <li class="H">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="PS">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="Z">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="PX">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="SS">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="PGV">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="R">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="T">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="TV">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="P">
                        <a href="#" style="color: White;"></a>
                      </li>

                      <li class="AC">
                        <a href="#" style="color: White;"></a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li class="counter-select-trigger">
                  <a
                    id="ctl00_HeaderCalculation_MainCalcHeader1_hlTariff"
                    title="Enotarifno merjenje"
                  >Enotarifno merjenje</a>
                  <ul class="counter-select" style="display: none;">
                    <li>
                      <a
                        id="ctl00_HeaderCalculation_MainCalcHeader1_LinkButton1"
                        title="Enotarifno merjenje"
                        href="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions(&quot;ctl00$HeaderCalculation$MainCalcHeader1$LinkButton1&quot;, &quot;&quot;, true, &quot;&quot;, &quot;&quot;, false, true))"
                      >Enotarifno merjenje</a>
                    </li>
                    <li>
                      <a
                        id="ctl00_HeaderCalculation_MainCalcHeader1_LinkButton2"
                        title="Dvotarifno merjenje"
                        href="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions(&quot;ctl00$HeaderCalculation$MainCalcHeader1$LinkButton2&quot;, &quot;&quot;, true, &quot;&quot;, &quot;&quot;, false, true))"
                      >Dvotarifno merjenje</a>
                    </li>
                  </ul>
                </li>
                <li class="right">
                  <a
                    href="Pregled_porabe_in_prihrankov.aspx"
                    id="ctl00_HeaderCalculation_MainCalcHeader1_lnkTotal"
                    title="Pregled celotne porabe in prihrankov"
                  >Pregled celotne porabe in prihrankov</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    my_arr: Object,
  },
  computed: {
    display_arr: function () {
      var arr = this.my_arr;
      return Object.keys(arr).reduce(function (filtered, key) {
        if (arr[key].length > 0) filtered[key] = arr[key];
        return filtered;
      }, {});
    },
  },
  data: function () {
    return {
      add_hover: 'none',
      app_hover: '',
    };
  },
};
</script>

<style>
</style>